module.exports = __webpack_public_path__ + "static/tree-8556553449e974e2b165de21036d2668.png";